(function () {
  var ORAL_VARIANT_IDS = ['45468180906053', '45468262105157', '45468305948741', '45468352675909', '45468368109637'];
  var checkoutBusy = false;

  function normalizeGate() {
    window.DermatoLogicCapilarGate = window.DermatoLogicCapilarGate || {};
    window.DermatoLogicCapilarGate.variantIds = ORAL_VARIANT_IDS.slice();
  }

  function isCartPage() {
    return window.location.pathname.indexOf('/cart') === 0;
  }

  function checkoutTarget(event) {
    if (!event.target || !event.target.closest) return null;
    return event.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function cartRequiresCapilarForm(cart) {
    return (cart.items || []).some(function (item) {
      return ORAL_VARIANT_IDS.indexOf(String(item.variant_id)) !== -1;
    });
  }

  function recetaValue() {
    var receta = document.getElementById('capilar-receta');
    return receta ? String(receta.value || '').toLowerCase() : '';
  }

  function selectedHasPrescription() {
    return recetaValue().indexOf('cuento con receta') !== -1;
  }

  function selectedNoPrescription() {
    return recetaValue().indexOf('no cuento') !== -1;
  }

  function syncUploadInputs() {
    var uploadBox = document.getElementById('capilar-receta-archivo-box');
    if (!uploadBox) return;
    uploadBox.querySelectorAll('input, select, textarea').forEach(function (field) {
      if (!field.getAttribute('form')) field.setAttribute('form', 'cart-form');
    });
  }

  function detectUploadedPrescription() {
    var uploadBox = document.getElementById('capilar-receta-archivo-box');
    if (!uploadBox || uploadBox.hidden) return '';
    syncUploadInputs();

    var fileInput = uploadBox.querySelector('input[type="file"]');
    if (fileInput && fileInput.files && fileInput.files.length > 0) return fileInput.files[0].name || 'Archivo cargado';

    var link = uploadBox.querySelector('a[href*="/uploads/"], a[href*="cdn.shopify"], a[href*=".pdf"], a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".heic"], a[href*=".webp"]');
    if (link && link.href) return link.href;

    var fields = uploadBox.querySelectorAll('input[type="hidden"], input[type="text"], textarea');
    var re = /(https?:\/\/|\/uploads\/|\.pdf|\.jpg|\.jpeg|\.png|\.heic|\.webp)/i;
    for (var i = 0; i < fields.length; i += 1) {
      var value = fields[i].value || '';
      if (re.test(value)) return value;
    }

    var text = (uploadBox.textContent || '').trim();
    if (/\.(pdf|jpg|jpeg|png|heic|webp)/i.test(text) || /archivo cargado|receta cargada|file uploaded|uploaded/i.test(text)) return 'Archivo cargado';
    return '';
  }

  function updatePrescriptionUi() {
    var uploadBox = document.getElementById('capilar-receta-archivo-box');
    var sinBox = document.getElementById('capilar-sin-receta-box');
    var sinCheck = document.getElementById('capilar-sin-receta-check');
    var status = document.getElementById('capilar-receta-archivo-status');
    var linkField = document.getElementById('capilar-receta-archivo-link');
    var fileName = document.getElementById('capilar-receta-archivo-nombre');
    var uploaded = '';

    if (uploadBox) {
      uploadBox.hidden = !selectedHasPrescription();
      if (selectedHasPrescription()) {
        syncUploadInputs();
        uploaded = detectUploadedPrescription();
      }
    }

    if (sinBox) {
      sinBox.hidden = !selectedNoPrescription();
      if (!selectedNoPrescription() && sinCheck) sinCheck.checked = false;
    }

    if (status) status.value = selectedHasPrescription() ? (uploaded ? 'Sí' : 'No adjuntada - opcional') : 'No aplica';
    if (linkField) linkField.value = uploaded || '';

    if (fileName && selectedHasPrescription()) {
      if (uploaded) {
        fileName.textContent = 'Receta cargada correctamente.';
        fileName.classList.add('is-ready');
      } else {
        fileName.textContent = 'Receta no adjuntada. Puedes continuar si aceptas la declaración.';
        fileName.classList.remove('is-ready');
      }
    }
  }

  function setWarning(box, message, show) {
    var warning = document.getElementById('capilar-warning');
    if (!warning) {
      warning = document.createElement('p');
      warning.id = 'capilar-warning';
      warning.className = 'capilar-warning';
      box.appendChild(warning);
    }
    warning.textContent = message;
    warning.hidden = !show;
  }

  function fieldIsValid(field) {
    if (field.disabled || field.closest('[hidden]')) return true;
    if (field.type === 'checkbox') return field.checked;
    if (field.type === 'file') return true;
    if (field.type === 'email' && field.value) return field.checkValidity();
    if (field.type === 'number' && field.value) return field.checkValidity();
    return Boolean((field.value || '').trim());
  }

  function validateCapilarForm(box, showWarning) {
    updatePrescriptionUi();

    var valid = true;
    var message = 'Completa el cuestionario y acepta las declaraciones para continuar al pago.';

    box.querySelectorAll('[data-capilar-required]').forEach(function (field) {
      if (!fieldIsValid(field)) valid = false;
    });

    var sinReceta = document.getElementById('capilar-sin-receta-check');
    if (selectedNoPrescription() && sinReceta && !sinReceta.checked) {
      valid = false;
      message = 'Acepta la declaración responsable para continuar sin receta médica.';
    }

    setWarning(box, message, showWarning && !valid);
    return valid;
  }

  function collectCartAttributes() {
    updatePrescriptionUi();
    var attributes = {};
    document.querySelectorAll('[name^="attributes["]').forEach(function (field) {
      if (field.disabled || field.type === 'file') return;
      var match = field.name.match(/^attributes\[(.+)\]$/);
      if (!match) return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      attributes[match[1]] = field.value || '';
    });
    return attributes;
  }

  function saveAttributesAndRedirect(target) {
    if (checkoutBusy) return;
    checkoutBusy = true;
    if (target && 'disabled' in target) target.disabled = true;

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: collectCartAttributes() })
    })
      .catch(function () {})
      .then(function () {
        window.location.href = '/checkout';
      });
  }

  function handleCheckoutAttempt(event, target) {
    event.preventDefault();
    event.stopImmediatePropagation();

    fetchCart()
      .then(function (cart) {
        var requiresForm = cartRequiresCapilarForm(cart);

        if (!requiresForm) {
          window.location.href = '/checkout';
          return;
        }

        if (!isCartPage()) {
          window.location.href = '/cart?formulario=capilar';
          return;
        }

        var box = document.querySelector('[data-capilar-form]');
        if (!box) {
          window.location.href = '/cart?formulario=capilar';
          return;
        }

        if (!validateCapilarForm(box, true)) {
          box.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        saveAttributesAndRedirect(target);
      })
      .catch(function () {
        window.location.href = isCartPage() ? '/checkout' : '/cart?formulario=capilar';
      });
  }

  function initFormBindings() {
    normalizeGate();
    var receta = document.getElementById('capilar-receta');
    var uploadBox = document.getElementById('capilar-receta-archivo-box');
    if (receta && receta.dataset.dermatologicBound !== 'true') {
      receta.dataset.dermatologicBound = 'true';
      receta.addEventListener('change', updatePrescriptionUi);
    }
    if (uploadBox && uploadBox.dataset.dermatologicBound !== 'true') {
      uploadBox.dataset.dermatologicBound = 'true';
      uploadBox.addEventListener('change', updatePrescriptionUi);
      uploadBox.addEventListener('input', updatePrescriptionUi);
      if (window.MutationObserver) new MutationObserver(updatePrescriptionUi).observe(uploadBox, { childList: true, subtree: true, attributes: true, characterData: true });
    }
    updatePrescriptionUi();
  }

  normalizeGate();
  document.addEventListener('DOMContentLoaded', initFormBindings);
  document.addEventListener('shopify:section:load', initFormBindings);
  setTimeout(initFormBindings, 500);
  setTimeout(initFormBindings, 1500);

  document.addEventListener('click', function (event) {
    var target = checkoutTarget(event);
    if (!target) return;
    handleCheckoutAttempt(event, target);
  }, true);

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    handleCheckoutAttempt(event, submitter);
  }, true);
})();
